import type { HTMLChakraProps } from '@chakra-ui/react'
import { chakra } from '@chakra-ui/react'

export const MarkBg = (props: HTMLChakraProps<'svg'>) => (
  <chakra.svg
    height='1521'
    width='auto'
    viewBox='0 0 1444 1521'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <g style={{ mixBlendMode: 'overlay' }}>
      <path
        d='M784.217 1004.52L784.231 1004.55L784.245 1004.58C799.935 1031.2 828.489 1047.56 859.389 1047.56H981.806C1010.14 1047.56 1027.76 1016.76 1013.41 992.359L727.572 506.475C713.403 482.388 678.597 482.388 664.428 506.475L378.534 992.359C364.179 1016.76 381.799 1047.56 410.135 1047.56H532.552C563.452 1047.56 592.006 1031.2 607.696 1004.58L607.71 1004.55L607.724 1004.52L683.466 863.793L683.498 863.734L683.524 863.673C683.589 863.522 683.657 863.427 683.784 863.25C683.863 863.14 683.965 862.999 684.102 862.792L684.99 861.461L683.605 860.661L629.941 829.663V753.466L695.97 715.339L762 753.466V829.663L708.336 860.661L706.951 861.461L707.838 862.792C707.952 862.962 708.059 863.123 708.162 863.284C708.273 863.455 708.378 863.627 708.484 863.81C708.487 863.816 708.49 863.821 708.493 863.826L784.217 1004.52ZM97.5 823.97C97.5 493.471 365.471 225.5 695.97 225.5C1026.53 225.5 1294.44 493.471 1294.44 823.97C1294.44 1154.47 1026.47 1422.44 695.97 1422.44C365.471 1422.44 97.5 1154.47 97.5 823.97Z'
        stroke='white'
        stroke-opacity='0.62'
        stroke-width='3'
      />
    </g>
    <g opacity='0.3' filter='url(#filter0_f_472_592)'>
      <ellipse cx='748' cy='760.5' rx='448' ry='460.5' fill='#181F2F' />
    </g>
    <g opacity='0.3' filter='url(#filter1_f_472_592)'>
      <ellipse cx='813' cy='752.5' rx='232' ry='238.5' fill='#0D1169' />
    </g>
    <defs>
      <filter
        id='filter0_f_472_592'
        x='0'
        y='0'
        width='1496'
        height='1521'
        filterUnits='userSpaceOnUse'
        color-interpolation-filters='sRGB'
      >
        <feFlood flood-opacity='0' result='BackgroundImageFix' />
        <feBlend mode='normal' in='SourceGraphic' in2='BackgroundImageFix' result='shape' />
        <feGaussianBlur stdDeviation='150' result='effect1_foregroundBlur_472_592' />
      </filter>
      <filter
        id='filter1_f_472_592'
        x='281'
        y='214'
        width='1064'
        height='1077'
        filterUnits='userSpaceOnUse'
        color-interpolation-filters='sRGB'
      >
        <feFlood flood-opacity='0' result='BackgroundImageFix' />
        <feBlend mode='normal' in='SourceGraphic' in2='BackgroundImageFix' result='shape' />
        <feGaussianBlur stdDeviation='150' result='effect1_foregroundBlur_472_592' />
      </filter>
    </defs>
  </chakra.svg>
)
